import { inject, Injectable } from "@angular/core";

import { AttachmentTargetEnum, AttachmentTypeEnum } from "@shared/enums";
import { IAttachment, IOrganisation } from "@shared/interfaces";
import { AttachmentsService, AuthenticationService, ConnectionsService } from "@shared/services";
import { CommonUtils } from "@shared/utils";

@Injectable({ providedIn: "root" })
export class LocationOrganisationService {
  private readonly authService = inject(AuthenticationService);

  private readonly connectionsService = inject(ConnectionsService);

  private readonly attachmentsService = inject(AttachmentsService);

  async get(id: string): Promise<IOrganisation> {
    const { targetUri } = await this.getAttachment(id);
    const orgId = CommonUtils.getUriId(targetUri);

    const org = await this.connectionsService.get(orgId);

    return org;
  }

  async getAttachment(id: string): Promise<IAttachment> {
    const orgId = this.authService.getActiveOrganisationId();

    const attachments = await this.attachmentsService.getAll(
      AttachmentTypeEnum.LOCATION,
      null,
      `/organisations/${orgId}/locations/${id}`,
    );

    return CommonUtils.getTargetAttachment(
      attachments,
      AttachmentTargetEnum.ORGANISATION,
      AttachmentTypeEnum.LOCATION,
      id,
    );
  }
}
